import { render, staticRenderFns } from "./PermitAdd.vue?vue&type=template&id=31364462"
import script from "./PermitAdd.vue?vue&type=script&lang=js"
export * from "./PermitAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports